import React from 'react';
import RevisionsDataTable from "./RevisionsDataTable";

const Revisions = () => {
    return (<RevisionsDataTable/>);
};

export default Revisions;